import { checkPermission, getParameterByIndex } from "helper/utils";
import { NavLink } from "react-router-dom";
import { RoleType } from "store/auth/auth.type";
import { MenuItem } from "./menu-items";

export type SidebarMenuItemProps = {
  item: MenuItem;
  roles: RoleType[];
};

export const SidebarMenuItem = ({ item, roles }: SidebarMenuItemProps) => {
  const currentPath = getParameterByIndex(0);
  const { path, menuIcon: MenuIcon } = item;

  const isActive = currentPath === path;
  const hasPermission = checkPermission(item.roles, roles);
  if (!hasPermission) {
    return <></>;
  }

  return (
    <li className={`relative ${isActive && "active"}`}>
      <NavLink to={path} className="h-45px justify-center flex items-center">
        <MenuIcon
          className={`h-8 w-8 fill-gray-100 text-gray-100 ${isActive ? "opacity-100" : "opacity-60"}  hover:opacity-100`}
        />
      </NavLink>
    </li>
  );
};
